import { render, staticRenderFns } from "./SystemLayout.vue?vue&type=template&id=aa1fd7bc&scoped=true&"
import script from "./SystemLayout.vue?vue&type=script&lang=js&"
export * from "./SystemLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1fd7bc",
  null
  
)

export default component.exports